import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';
import { useContext, useCallback } from 'react';
import { getVariation } from '@vp/ab-reader';
import { experimentConfig } from './src-config-experiment-config.js';
import { CAContext } from './src-contexts-CAContext.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';

const useCustomTracking = () => {
  const {
    chatState: { chatSession }
  } = useContext(CAContext);
  const {
    state: { sessionId }
  } = useContext(ChatbotContext);
  const { logCustomAttributesNR } = useNRLogging();
  const sendExperimentEvent = useCallback((experimentDetail) => {
    try {
      const variationKey = getVariation(experimentConfig.experimentName);
      const expEventDetails = {
        //   label: `${requestor} View`,
        experimentName: experimentConfig.experimentName,
        variationName: variationKey,
        experimentDetail
      };
      window?.tracking?.track("Experiment Clicked", { ...expEventDetails });
    } catch (err) {
      const error = err;
      logCustomAttributesNR("help-anywhere-error-events-experiment", {
        logLevel: "error",
        message: "Event",
        errorName: error.name,
        errorMessage: error.message,
        experimentDetail
      });
    }
  }, []);
  const sendTrackingEvent = useCallback(
    (eventName, label, eventDetail, category, additionalInfo) => {
      try {
        let eventCategory = category;
        if (!eventCategory) {
          eventCategory = "GEN AI Chatbot";
        }
        const eventDetails = {
          label,
          category: eventCategory,
          eventDetail,
          ...additionalInfo
        };
        if (chatSession === "chatbotSession") {
          eventDetails.chatbotSessionId = sessionId;
        }
        window?.tracking?.track(eventName, eventDetails);
      } catch (err) {
        const error = err;
        logCustomAttributesNR("ca-chatbot-error-events", {
          eventName,
          label,
          errorName: error.name,
          errorStack: error.stack,
          message: error.message,
          logLevel: "error"
        });
      }
    },
    [chatSession, sessionId]
  );
  return { sendExperimentEvent, sendTrackingEvent };
};

export { useCustomTracking };
//# sourceMappingURL=src-hooks-custom-hooks-useTracking.js.map
